// import * as React from 'react';
// import {
// 	Dropdown, IDropdownOption
// } from 'office-ui-fabric-react';
// import { IComponent, IComponentDictionary, IBranch, IUiElement } from '../../helpers';

// interface IProps {
// 	allConditions: IBranch[];
// 	conditions: IBranch;
// 	conditionIndex: number;
// 	component: IComponent;
// 	components: IComponentDictionary;
// 	element: IUiElement;
// 	branchName: string;
// 	setNextComponentId: (elementId: string, componentId: string, nextComponentId: string, elementType: string) => any;
// }

// export class BranchSelector extends React.Component<IProps, any> {
// 	setActiveBranch = (a) => {
// 		console.log("Setting active branch:", this.props.element, a)
// 		let nextComponentId = this.props.element.componentId + "_" + a.key + "_ADD";
// 		this.props.setNextComponentId(
// 			this.props.element.elementId,
// 			this.props.element.componentId,
// 			nextComponentId,
// 			this.props.element.type
// 		);
// 	}

// 	render() {
// 		console.log('branch selector elements ----> ', this.props.components);

// 		let style = `body {
// 			.conditions-wrapper {
// 				display: table;
// 				border-collapse: separate;
// 				border-spacing: 5px;
// 				table-layout: fixed;
// 				min-width: 100%;
// 			}

// 			.conditions {
// 				display: flex;
// 			}

// 			.conditions > .children {
// 				display: table-cell;
// 				border: 1px solid #AAA;
// 				margin: 5px;
// 				flex: 1;
// 			}
// 		}`;


// 		let { allConditions, conditions, conditionIndex, element } = this.props;

// 		let allBranches: IDropdownOption[] = allConditions.map((condition, index) => {
// 			return { index: index, text: condition.Name || "Condition " + index, key: index };
// 		});
// 		let branches: IDropdownOption = { index: conditionIndex, text: conditions.Name || "Condition " + conditionIndex, key: conditionIndex };

// 		// parse the element id of the following add button, and grab the selected branch number;
// 		let selectedKey = parseInt(element.nextElementId.match(/_.+_/ig)[0].replace("_", "").replace("_", ""));
// 		console.log('selectedkey ----> ', conditionIndex, selectedKey, element.nextElementId.match(/_.+_/ig)[0]);
// 		return <div className="">
// 			<div key={0} className={"ui-only anim-1 ms-u-slideRightIn40 in-branch"}>
// 				<style dangerouslySetInnerHTML={{ __html: style }} ></style>
// 				<div className="conditions">

// 					{/* {branches.map(branch => ( */}
// 					<div key={branches.key} className="children decision decision_start component-inner component-summary">

// 						{
// 							branches && <Dropdown
// 								label={branches.text}
// 								options={allBranches}
// 								onChanged={(a) => { this.setActiveBranch(a); }}
// 								selectedKey={selectedKey} />
// 						}
// 						{
// 							Object.keys(branches).length == 0 && <span>Please configure a condition before using the branch selector</span>
// 						}

// 					</div>

// 					{/* ))} */}

// 				</div>

// 			</div>
// 		</div>;
// 	}
// }

import * as React from 'react';
// import { useState } from 'react';
import store from '../../store/store';
import {
	Dropdown, IDropdownOption
} from 'office-ui-fabric-react';
import { IComponent, IComponentDictionary, IBranch, IUiElement, EModalType } from '../../helpers';
import Collapsible from 'react-collapsible';
import DecisionConfigContainer from '../../containers/decision-config';
import OutputSelectContainer from "../../containers/output-select";

interface IProps {
	conditions: IBranch[];
	component: IComponent;
	components: IComponentDictionary;
	element: IUiElement;
	index: number;
	setNextComponentId: (elementId: string, componentId: string, nextComponentId: string, elementType: string) => any;
	toggleDecisionConfigDialog?: (componentId: string, previousOutputBlocks: any) => void;
	previousOutputBlocks?: any;


}

export class BranchSelector extends React.Component<IProps, any> {
	state = {
		elements: {},
		shownElements: []
	}

	setActiveBranch = (a) => {
		let nextComponentId = this.props.element.componentId + "_" + a.key + "_ADD";
		this.props.setNextComponentId(
			this.props.element.elementId,
			this.props.element.componentId,
			nextComponentId,
			this.props.element.type
		);
	}

	componentDidMount() {
		let nextComponentId = this.props.element.componentId + "_" + this.props.index + "_ADD";
		this.props.element.nextElementId = nextComponentId;
		this.props.setNextComponentId(
			this.props.element.elementId,
			this.props.element.componentId,
			nextComponentId,
			this.props.element.type
		);
	}


	render() {

		let { conditions, element, index, previousOutputBlocks, toggleDecisionConfigDialog } = this.props;

		let branches: IDropdownOption[] = conditions.map((condition, index) => {
			return { index: index, text: condition.Name || "Condition " + index, key: index };
		});

		// parse the element id of the following add button, and grab the selected branch number;
		let selectedKey = parseInt(element.nextElementId.match(/_.+_/ig)[0].replace("_", "").replace("_", ""));

		return <div key={index} className={"component ui-only anim-1 ms-u-slideRightIn40 branch-selector cascade"}>
			<Collapsible overflowWhenOpen="visible" open={true} trigger={
				<div onClick={() => {
					toggleDecisionConfigDialog(element.componentId, previousOutputBlocks)
				}}>
					{/* <span className="branch-badge badge-circle badge-top" title="Branching conditions">
						<i className="ms-Icon ms-Icon--BranchFork" aria-hidden="true"></i>
					</span> */}
				</div>}
			>
				<DecisionConfigContainer
					branchIndex={index}
					conditions={conditions}
					componentId={element.componentId}
					previousOutputBlocks={previousOutputBlocks}
					toggleDecisionConfigDialog={toggleDecisionConfigDialog} />

			</Collapsible>
			{/* <div className="decision decision_start component-inner component-summary">
					{
						branches.length > 0 && <Dropdown
							label={branches[index].text}
							options={branches}
							onChanged={(a) => { this.setActiveBranch(a); }}
							selectedKey={branches[index].key} />
						// selectedKey={selectedKey} />
					}
					{
						branches.length === 0 && <span>Please configure a condition before using the branch selector</span>
					}
				</div> */}

			{/* <DecisionConfigContainer branchIndex={index} componentId={element.componentId} previousOutputBlocks={previousOutputBlocks}
				toggleDecisionConfigDialog={toggleDecisionConfigDialog} /> */}


			{/* Prevent token dropdown menu from appearing in other decision branches within the journey */}
			{
				store.getState().modalState.modal.openModal === EModalType.DecisionConfig &&
					store.getState().modalState.decisionConfig.componentId === element.componentId &&
					store.getState().modalState.decisionConfig.branchEditIndex === index
					? <OutputSelectContainer /> : null}
		</div >;
	}
}



// WEBPACK FOOTER //
// ./source/ts/components/components/branch-selector.tsx